import { apiMipe } from '@/core/api/';
import applicationTypes from '@/utils/constants/applicationTypes';
import qs from 'querystring';

export const getRegions = async (model) => {
  return apiMipe.get('api/location/regions', {
    params: {
      ...model,
    },
  });
};

export const getDistricts = async (model) => {
  return apiMipe.get('api/location/districts', {
    params: {
      ...model,
      applicationType: applicationTypes.PortalProveedor,
    },
  });
};

export const getMunicipalities = async (model) => {
  return apiMipe.get('api/location/municipalities', {
    params: {
      ...model,
    },
  });
};

export const getSchools = async (model) => {
  return apiMipe.get('api/location/schools', {
    params: {
      ...model,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
};

export const getCenters = async (model) => {
  return apiMipe.get('api/location/centers', {
    params: {
      ...model,
      applicationType: applicationTypes.PortalProveedor,
    },
  });
};

export const getActiveRegions = async () => {
  return await apiMipe.get('api/location/activeregions');
};
